(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("eva", [], factory);
	else if(typeof exports === 'object')
		exports["eva"] = factory();
	else
		root["eva"] = factory();
})(typeof self !== "undefined" ? self : this, function() {
return 